import { render, staticRenderFns } from "./RoomMenu.vue?vue&type=template&id=6f190e4c&scoped=true&lang=pug&"
import script from "./RoomMenu.vue?vue&type=script&lang=js&"
export * from "./RoomMenu.vue?vue&type=script&lang=js&"
import style0 from "./RoomMenu.vue?vue&type=style&index=0&id=6f190e4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f190e4c",
  null
  
)

component.options.__file = "RoomMenu.vue"
export default component.exports